import { TokenAdmService } from './../../services/token-adm.service';
import { PerfilUsuarioService } from './../../services/perfil-usuario.service';
import { ActivatedRoute,Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2'
import { BurbujaService } from 'src/app/services/burbuja.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-burbuja',
  templateUrl: './burbuja.component.html',
  styleUrls: ['./burbuja.component.css']
})
export class BurbujaComponent implements OnInit {

  formu: FormGroup;
  loadingPerfiles:boolean=false;
  loadingBurbujas:boolean=false;
  titulo:string
  burbujaId:number;
  perfiles:any;
  objBurbuja:any;
  ruta:string;
  esAlta:boolean=false;
  isAdmin:boolean;
  isContribuidor:boolean;

  constructor( private fb: FormBuilder, private location:Location, private activatedRoute:ActivatedRoute,
               private burbuService:BurbujaService, private router:Router, private perfilService:PerfilUsuarioService, private tokenService:TokenAdmService) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params =>{
      this.burbujaId = params['burbujaId'];
     })

    this.cargarPerfiles();
    this.crearFormulario();
    this.cargarDataAlFormulario();
    sessionStorage.setItem('origen','');
    this.isAdmin = this.tokenService.hasRole('Help_Admin')
    this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor')

  }

  get nombreNoValido() {
    return this.formu.get('nombre').invalid && this.formu.get('nombre').touched
  }

  get descripcionNoValida() {
    return this.formu.get('descripcion').invalid && this.formu.get('descripcion').touched
  }

  get perfilNoValido() {
    return this.formu.get('perfilUsuario').invalid && this.formu.get('perfilUsuario').touched
  }

  crearFormulario() {

    this.formu = this.fb.group({
      nombre  : ['', [ Validators.required, Validators.minLength(1), Validators.maxLength(50) ]  ],
      descripcion: ['', [Validators.required, Validators.maxLength(250)] ],
      perfilUsuario: ['',[Validators.required]],
    });
  }


  cargarDataAlFormulario() {
      if (this.burbujaId==0){
      this.titulo = 'Crear Burbuja'
      this.esAlta = true;
    }
    else {
      this.titulo = 'Editar Burbuja'
      this.esAlta = false;
      this.cargarBurbuja();
    }
}

  get perfilUsuario() {
    return this.formu.get('perfilUsuario');
  }

  cambiarPerfil(e) {
    this.perfilUsuario.setValue(e.target.value, {
      onlySelf: true
    })
  }


  guardar() {
    //validación de que el form sea valido
    if ( this.formu.invalid ) {
      return Object.values( this.formu.controls ).forEach( control => {
        if ( control instanceof FormGroup ) {
          Object.values( control.controls ).forEach( control => control.markAsTouched() );
        } else {
          control.markAsTouched();
        }
      });
    }


    let textoConfirmacion:string
    let tituloConfirmacion:string
    if (this.burbujaId ==0){
      tituloConfirmacion = 'Crear Burbuja'
      textoConfirmacion = '¿Confirmas la creación de la burbuja?'
    }
    else{
      tituloConfirmacion = 'Modificar Burbuja'
      textoConfirmacion = '¿Confirmas la modificación de la burbuja?'
    }


    Swal.fire({
      title: tituloConfirmacion,
      html: textoConfirmacion,
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {

        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
        });
        Swal.showLoading();

        let peticion: Observable<any>;
        let tituloMensaje:string;
        let textoMensaje:string;
        let nombre = this.formu.get('nombre').value;

        if (this.burbujaId==0) {
          tituloMensaje = 'Burbuja creada';
          textoMensaje = `La burbuja "${nombre}" ha sido creada correctamente`
          peticion =  this.burbuService.crearBurbuja(this.formu.getRawValue());
        } else {
          tituloMensaje = 'Burbuja modificada';
          textoMensaje = `La burbuja "${nombre}" ha sido modificada correctamente`
          peticion =  this.burbuService.modificarBurbuja(this.burbujaId,this.formu.getRawValue())
        }
        let timerInterval
        peticion.subscribe({
          next: resp => {
            if (this.esAlta){
              this.burbujaId=resp;
            }
          Swal.fire({
            title: tituloMensaje,
            text: textoMensaje,
            icon: 'success',
            timer: 1500,
            timerProgressBar: true,
             willClose: () => {
              clearInterval(timerInterval)
              this.volver();
            },
            didOpen: () => {
              Swal.showLoading()
              const b = Swal.getHtmlContainer().querySelector('b')
              timerInterval = setInterval(() => {
                if (b){
                  b.textContent = Swal.getTimerLeft()?.toString()
                }
              }, 100)
            }
          }).then(resp => {
            if (resp.isConfirmed) {
              this.ruta = '/help';
              this.router.navigateByUrl(this.ruta);
          }})
        },
        error: error => {
          console.error(error.error);
          Swal.fire({
            title: 'No se pudo actualizar la burbuja',
            text: `Ocurrió un error al intentar actualizar en la base de datos la burbuja ${nombre}`,
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      })
     }
    })
  }

  cargarPerfiles(){
    this.loadingPerfiles = true;
    this.perfilService.getPerfilesActivos().subscribe(
      resp => {
        this.perfiles = resp;
        this.loadingPerfiles=false;
      },
      error => {
        console.error(error);
        this.loadingPerfiles=false;
      }
     )
  }

  cargarBurbuja(){
    this.loadingBurbujas = true;
    this.burbuService.getById(this.burbujaId).subscribe(
      resp => {
        this.objBurbuja = resp;
        this.formu.reset({
          nombre: this.objBurbuja.nombre,
          descripcion: this.objBurbuja.descripcion,
          perfilUsuario: this.objBurbuja.perfilUsuario.id
        })
        this.loadingBurbujas = false;
      },
      error => {
        console.error(error);
        this.loadingBurbujas = false;
      }
     )
  }



  volver() {
    this.router.navigateByUrl(sessionStorage.getItem('origenBurbuja'));
  }

}


